<script>
import { mapState } from 'vuex'
export default {
  name: 'Inlay',
  props: [
    'inlay',
    'anchors',
    'physical',
  ],
  emits: [
    'computedInlayDimensions',
    'createdAlignmentAnchors'
  ],
  computed: {
    inlaySRC() { return this.$apiURL + this.inlay.url },
    scaleFactor() {
      return this.physical ? this.physicalScaleFactor : 1
    },
    ...mapState(['isMobile'])
  },
  methods: {
    createAlignmentAnchors() {
      const
        imgLeft   = this.$refs.img.offsetLeft + this.$refs.imgContainer.offsetLeft,
        imgTop    = this.$refs.img.offsetTop + this.$refs.imgContainer.offsetTop,
        imgWidth  = this.$refs.img.offsetWidth,
        imgHeight = this.$refs.img.offsetHeight,

        alignmentAnchors = []

      this.$emit('computedInlayDimensions', {
        x : imgLeft,
        y : imgTop,
        w : imgWidth,
        h : imgHeight,
      })

      for (let anchor of this.anchors) {
        if (anchor.positionInInlay) {
          const alignmentAnchor = {
            for    : anchor.slug,
            left   : imgLeft + anchor.positionInInlay.left * imgWidth,
            top    : imgTop + anchor.positionInInlay.top * imgHeight,
            width  : anchor.positionInInlay.width * imgWidth,
            height : anchor.positionInInlay.height * imgHeight,
          }
          alignmentAnchors.push(alignmentAnchor)
        }
      }
      this.$emit('createdAlignmentAnchors', alignmentAnchors)
    }
  },
  mounted() {
    let doit
    window.addEventListener('resize', () => {
      clearTimeout(doit)
      doit = setTimeout(() => {
        this.createAlignmentAnchors()
      }, 100)
    })
  }
}
</script>

<template>
  <div id="inlay">
    <div
      ref="imgContainer"
      class="imgContainer"
    >
      <img
        ref="img"
        :src="inlaySRC"
        @load="createAlignmentAnchors"
      />
      <div
        class="instruction"
        v-if="physical"
      >
        <span v-if="isMobile">
          Please use a desktop browser to play this game.
        </span>
        <span v-else>
          Place the printed map you received over your screen and resize your browser so that it fits in this box.
        </span>
      </div>
    </div>
  </div>
</template>

<style scoped>
#inlay {
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 400;
  pointer-events: none;
  display: flex;
  justify-content: center;
  align-items: flex-end;
}
#inlay .imgContainer {
  position: relative;
  box-sizing: border-box;
   display: flex;
  justify-content: center;
  align-items: flex-end;
}
#inlay .imgContainer img {
  max-width: 100%;
  max-height: 100%;
  height: 100%;
}
.physical #inlay {
  padding-left: 6em;
  padding-right: 6em;
  padding-bottom: 2em;
}
.physical #inlay .imgContainer {
  position: relative;
  border: 2px dashed white;
  border-top: 0;
  /* margin: auto; */
}
.physical #inlay .imgContainer img {
  opacity: 0;
}
.physical #inlay .imgContainer .instruction {
  position: absolute;
  bottom: 1em;
  color: white;
  width: 100%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.physical #inlay .imgContainer .instruction span {
  max-width: 500px;
  margin: 0 2em;
}

.isMobile #inlay .imgContainer {
  margin: auto;
  align-items: center;
}

@media screen and (max-width : 1100px)  and (min-width : 750px) {
  #inlay .imgContainer {
    margin: auto;
    padding: 0rem;
    /* align-items: center; */
  }
}

</style>
